const SectionHeading = ({ children = "", className = "", ...props }) => {
  return (
    <h2
      className={`font-bold font-sans uppercase tracking-[-1.25px] laptop:tracking-[-3px] gradient-text bg-left-bottom bg-textGd ${className}`}
      style={{
        fontSize: "clamp(1.625rem, 1.087rem + 2.69vw, 3.75rem)",
        lineHeight: "clamp(1.625rem, 1.087rem + 2.69vw, 3.2rem)",
      }}
      {...props}
    >
      {children}
    </h2>
  );
};

const SubPageSectionHeading = ({ children = "", className = "", ...props }) => {
  return (
    <h2
      className={`sectionSubhHeading font-bold font-sans uppercase tracking-[-1.25px] laptop:tracking-[-2px] gradient-text bg-left-bottom bg-textGd ${className}`}
      style={{
        fontSize: "clamp(1.5rem, 1.326rem + 1.087vw, 2.5rem)", // 40px
        lineHeight: "clamp(1.5rem, 1.326rem + 1.087vw, 2.5rem)",
      }}
      {...props}
    >
      {children}
    </h2>
  );
};

const SectionDetail = ({ children = "", className = "", ...props }) => {
  return (
    <p
      className={`font-medium tracking-[-0.8px] text-gunMetal ${className}`}
      style={{
        fontSize: "clamp(1rem, 0.905rem + 0.475vw, 1.25rem)", // 20px
        lineHeight: "clamp(1.5rem, 1.373rem + 0.633vw, 2rem)",
      }}
      {...props}
    >
      {children}
    </p>
  );
};

const SubPageSectionDetail = ({ children = "", className = "", ...props }) => {
  return (
    <p
      className={`font-semibold tracking-[-0.6px] text-gunMetal ${className}`}
      style={{
        fontSize: "clamp(1rem, 0.968rem + 0.158vw, 1.125rem)", // 18px
        lineHeight: "clamp(1.5rem, 1.373rem + 0.633vw, 1.5rem)",
      }}
      {...props}
    >
      {children}
    </p>
  );
};

export {
  SectionHeading,
  SubPageSectionHeading,
  SectionDetail,
  SubPageSectionDetail,
};
